import DaoProducts from "./DaoProducts";
import DaoPlancha from "./DaoPlancha";
import FooterServices from "./FooterServices";

const Services = () => {
  return (
    <div>
      <DaoProducts />
      <DaoPlancha />
      <FooterServices />
    </div>
  );
};

export default Services;
